const NoQuizzesCard: React.FC = () => {
  return <div>No quizzes</div>
}

export default NoQuizzesCard
